﻿export class DateUtilities {
    public convertUtcDateToUserLocalDate(utcDate: Date | string | number): Date {
        if (utcDate instanceof Date) {
            utcDate = utcDate.getTime();
        }

        return new Date(utcDate);
    }

    public getUsersTimeZoneOffset(): number {
        return new Date().getTimezoneOffset();
    }

    public getUsersTimeZoneName(): string | null {
        return Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
    }
}